module.exports = __webpack_public_path__ + "img/legionpool-h-474x356.42a74ca5.jpg";